import { Card, Container, Flex, Heading, Loader, Stack, Box, EmptyState, EmptyStateList } from "@eworkit/iris";
import React from "react";
import { FC } from "react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";

import { UserContext } from "@/components/User";
import { fetchMostRecentJobRequests } from "@/data/job-requests";

import { DashboardRecentlyViewedItem } from "../components";

interface DashboardRecentlyViewedSectionProps {}

export const DashboardRecentlyViewedSection: FC<DashboardRecentlyViewedSectionProps> = ({}) => {
  const User = useContext(UserContext);
  const companyId = User.contextCompany?.id;
  const { t } = useTranslation("session");
  const { data, isFetching } = useQuery(["dashboard-recent-jobs"], () => fetchMostRecentJobRequests({ companyId }), {
    suspense: false,
  });

  return (
    <Container as={Card} sx={{ gridColumn: ["1 / 5", null, null, "3 / 5"] }}>
      <Container
        sx={{
          minHeight: "150px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          pt: ["0", null, null, "xs"],
        }}>
        <Heading as={Box} pb="xxs" size={["h-md", null, null, "h-lg"]}>
          {t("DASHBOARD.RECENTLY_VIEWED_WIDGET.HEADER")}
        </Heading>

        {isFetching ? (
          <Flex flex={1} alignItems="center" justifyContent="center">
            <Loader size="xl" />
          </Flex>
        ) : data?.length == 0 ? (
          <Flex flex={1} alignItems="center" justifyContent="center">
            <Box py="lg">
              <EmptyState
                icon={<EmptyStateList />}
                title={""}
                content={t("DASHBOARD.RECENTLY_VIEWED_WIDGET.EMPTY_SUBHEADER")}
              />
            </Box>
          </Flex>
        ) : (
          <Flex as={Box} pt="sm" pb={["0", null, null, "sm"]} flex={1} alignItems="start" justifyContent="center">
            <Stack as={Container} gap="sm">
              {data && data.slice(0, 2).map(item => <DashboardRecentlyViewedItem key={item.id} item={item} />)}
            </Stack>
          </Flex>
        )}
      </Container>
    </Container>
  );
};
